import { MessageCircle } from "lucide-react";
import { Reveal, GoldButton, GhostButton } from "@/components/Reveal";
import { WHATSAPP_LINK, scrollToId } from "@/constants/site";

export const FinalCTA = () => (
  <section data-testid="final-cta-section" className="grain relative overflow-hidden bg-obsidian px-5 py-24 sm:px-8 sm:py-32 lg:px-16 lg:py-40">
    <div className="pointer-events-none absolute left-1/2 top-1/2 h-[480px] w-[720px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold/[0.06] blur-[120px]" />
    <div className="relative mx-auto max-w-4xl text-center">
      <Reveal>
        <h2 className="font-serif text-4xl font-light leading-tight tracking-tight text-zinc-50 sm:text-6xl">
          Your Next Journey <span className="italic text-gold-gradient">Starts Here.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mx-auto mt-6 max-w-xl text-base font-light leading-relaxed text-zinc-400 sm:text-lg">
          Tell us where you want to go, what you want to experience and what you're comfortable spending.
        </p>
      </Reveal>
      <Reveal delay={0.25}>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <GoldButton testId="final-plan-cta" onClick={() => scrollToId("plan")}>
            Plan My Journey
          </GoldButton>
          <GhostButton testId="final-whatsapp-cta" href={WHATSAPP_LINK}>
            <MessageCircle size={16} />
            Chat With Us
          </GhostButton>
        </div>
      </Reveal>
    </div>
  </section>
);
